(function ($) {
    $(document).ready(function () {
        var sections = $('.section.localmeasure_section');

        sections.each(function (index) {
            var section = $(this);
            observer = new IntersectionObserver(function(entry, observer){
                if(entry[index].intersectionRatio > 0){
                    var images = section.find('.images');
                    var lm_id = section.data('localmeasure-id');
                    if (lm_id) {
                        var url = 'https://cdn.getlocalmeasure.com/public/' + lm_id + '/data.js';
                        $.ajax({
                            url: url,
                            dataType: 'jsonp',
                            jsonpCallback: 'jsonCallback_' + lm_id,
                            success: function (data) {
                                if (data.posts && data.posts.length > 0) {
                                    data.posts = data.posts.slice(local_measure_images_sorter.start, local_measure_images_sorter.end);
                                    $.each(data.posts, function (key, post) {
                                        if (post.kind === 'photo' || post.kind === 'slideshow' /* TODO Handle video too */) {

                                            var image = '';
                                            var link = '#';
                                            var source = 'instagram';
                                            switch (post.kind) {
                                                case 'photo':
                                                    image = post.images[0].url || '';
                                                    link = post.source.link;
                                                    break;
                                                case 'slideshow':
                                                    image = post.images[0].url || '';
                                                    link = post.source.link;
                                                    break;
                                            }

                                            var post_container = $('<div/>',  {
                                                'class': 'thumb_wrap'
                                            });
                                            var thumb = $('<div/>',  {
                                                'class': 'thumb'
                                            });
                                            var a = $('<a/>',  {
                                                'style': 'background-image:url("' + image + '");',
                                                'target': '_blank',
                                                'href': link
                                            });
                                            var span = $('<span/>',  {
                                                'class': 'icon ' + source
                                            });

                                            a.append(span);
                                            thumb.append(a);
                                            post_container.append(thumb);
                                            images.append(post_container);
                                        }
                                    });
                                    if($(window).width() < 768){
                                        var all_images = section.find('.images').children();
                                        if(all_images.length > 0){
                                            section.find('.images').not('.slick-initialized').slick({
                                                rows:0,
                                                slidesToShow: 1,
                                                centerMode: true,
                                                centerPadding: '40px',
                                                rtl: $('html').attr('dir') === 'rtl',
                                                nextArrow: accor_arrow_next,
                                                prevArrow: accor_arrow_prev,
                                            });
                                        }
                                    }
                                }
                            }
                        })
                        .fail(function () {
                            window.console && console.log('Localmeasure Error', url);
                            section.hide();
                        });
                    }
                    observer.unobserve(section[index]);
                }
            });
            observer.observe(section[index]);
        });
    });
})(jQuery);